import { View } from 'foundations-components/components/View';
import AsyncSingleReportViewerSidebarContainer from 'reporting-enablement/components/singleReportViewer/AsyncSingleReportViewerSidebarContainer';
import { tracker } from '../../tracking/usageTracker';
import { useReportToRender } from '../hooks/useReportToRender';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportPageSidebar = () => {
  const {
    reportToRender,
    handlePreviewReportChange
  } = useReportToRender();
  if (!reportToRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "700",
    children: /*#__PURE__*/_jsx(AsyncSingleReportViewerSidebarContainer, {
      report: reportToRender,
      onPreviewReportChangeCallback: handlePreviewReportChange,
      track: tracker
    })
  });
};